import { useGetManagedEmployerQuery } from "@js/apps/employer/hooks";
import { useSafeJobFormContext } from "@js/apps/jobs/context/job-form-context/job-form-context";

export const useEmployerMaxOpeningsNumber = () => {
  const { data: employer } = useGetManagedEmployerQuery();
  const jobFormContext = useSafeJobFormContext();
  const jobMaxOpeningsNumber =
    jobFormContext?.jobToEdit?.limitations?.max_openings_number;

  if (jobMaxOpeningsNumber !== undefined) {
    return jobMaxOpeningsNumber;
  }

  return (
    employer?.override_maximum_openings_number ??
    SETTINGS.JOB_MAX_OPENINGS_NUMBER
  );
};
